<template>
  <vue-good-table 
    styleClass="vgt-table condensed"
    :columns="columns"
    :rows="rows"
    :sort-options="{enabled: false}"
    max-height="200px"
    compactMode>
    <template #table-row="props">
      <div
        v-if="props.column.field === 'RewardName'"
        class="d-flex align-items-center gap-2"
      >
        <button
          v-if="props.row.RewardID"
          type="button"
          class="forum-bubble-btn"
          :class="{ 'forum-bubble-btn-dark': isDarkMode }"
          :title="'Fórum: ' + (props.row.RewardName || 'výhra')"
          @click.stop="openRewardForum(props.row)"
        >
          <fa-icon icon="fa-regular fa-comment-dots" />
        </button>
        <span>{{ props.formattedRow[props.column.field] }}</span>
      </div>
      <span v-else>{{ props.formattedRow[props.column.field] }}</span>
    </template>
    <template #emptystate>
      <div class="text-center">
        <span>Žádná data</span>
      </div>
    </template>
  </vue-good-table>
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  rows: Array
});

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);

const formatFn = (value) => { return store.getters.formatTableNumber(value) };

const openRewardForum = (row) => {
  if (!row?.RewardID) return;
  store.dispatch('openForum', {
    title: row.RewardName || 'Výhra',
    RewardID: row.RewardID,
    Img: row.RewardImg
  });
};

const columns = reactive([
  { 
    label: 'Výhra',
    field: 'RewardName',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
  { 
    label: 'Pořadí',
    field: 'RewardOrder',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-md-center',
    tdClass: 'text-sm font-weight-bold text-md-center',
  },
  { 
    label: 'Hodnota',
    field: 'RewardCredit',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end',
    formatFn: formatFn
  }
]);

</script>

<style scoped>
.forum-bubble-btn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1.5px solid #CBD5E1;
  background: transparent;
  color: #64748B;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 0.7rem;
}

.forum-bubble-btn:hover {
  color: #FF8A4C;
  border-color: #FF8A4C;
  background: rgba(255, 138, 76, 0.08);
}

.forum-bubble-btn-dark {
  border-color: #475569;
  color: #94A3B8;
}

.forum-bubble-btn-dark:hover {
  color: #FF8A4C;
  border-color: #FF8A4C;
  background: rgba(255, 138, 76, 0.14);
}
</style>
